import { render, staticRenderFns } from "./SupplierManufacturingEthical.vue?vue&type=template&id=2dc9f30c&scoped=true&"
import script from "./SupplierManufacturingEthical.vue?vue&type=script&lang=js&"
export * from "./SupplierManufacturingEthical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc9f30c",
  null
  
)

export default component.exports